export const CANONICAL_ORIGIN = "https://www.legendarylogcabin.com";
